<script lang="ts">
	// Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';

	// Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { status_configurator } from 'src/helpers/device_data_helpers';
	import { capFirstChar } from 'src/helpers/utilities';

	// Services and configs
	import { devices_config } from 'src/configs/devices';

	// Design System Components
	import { ParameterCardV2 } from '@Shelly/shelly-design-system';
	// Helpers
	import { mapIconToThin } from 'src/helpers/new-layout-helpers';

	// Components
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';

	// Types
	import type { Device } from 'src/types/Device.ts';
	import { createGen1StatusLabels } from '../../SidePanelLayoutProvider/SidePanelDeviceLayout/Devices/Shelly/Gen1/gen1-main-helpers';
	import DeviceLabelList from '../DeviceLabelList.svelte';

	export let device: Device;

	$: deviceConfig = devices_config?.[device?.type];

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	// Status processing
	$: _statuses = status?.online && deviceConfig ? status_configurator(status, device, settings) : [];
	$: powerStatus = Array.isArray(_statuses)
		? _statuses.filter((s) => s.name === 'power')[0]
		: undefined;

	$: labelList = createGen1StatusLabels(_statuses);
</script>

<DeviceViewStateWrapper {device}>
	<div slot="staticTop">
		<DeviceLabelList {labelList} />
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>
	<div class="flex-full-height justify-content-end" slot="staticBottom">
		{#if powerStatus}
			<ParameterCardV2
				backgroundColor="--color-0"
				size="s"
				icon={mapIconToThin('fas fa-plug')}
				title={powerStatus?.value}
				description={capFirstChar('Power')}
			/>
		{/if}
	</div>
</DeviceViewStateWrapper>
